import { Injectable } from '@angular/core';
import { environment } from '@teem/environments/environment';
import { SharedDataService } from '@teem/services/shared-data.service';
import mixpanel from 'mixpanel-browser';

@Injectable({
	providedIn: 'root'
})

export class MixpanelService {
	private mixpanelToken: string;
	userInfo: any;
	private currentUserProperties: any = {};

	/**
	 * constructor
	 * get mixpanel token and initialize
	 */
	constructor(private sharedDataService: SharedDataService) {
		this.mixpanelToken = environment.mixpanel_token;
		this.init();
	}

	/**
	 * Initialize mixpanel.
	 */
	init(): void {
		mixpanel.init(this.mixpanelToken);
		this.sharedDataService.asObservable().subscribe((data) => {
			if (data) {
			  if (data.userInfo) {
				this.userInfo = data.userInfo
				this.identify(this.userInfo?.id);
			  }
			}
		})
	}


	/**
	 * Create new Alias for user
	 * Call this method only once in user lifecycle
	 *
	 * @param {string} alias
	 */
	createAlias(alias: string) {
		mixpanel.alias(alias, mixpanel.get_distinct_id());
	}

	/**
	 * Identify User
	 *
	 * @param {string} alias
	 */
	identify(alias: string) {
		mixpanel.identify(alias);
	}

	/**
	 * Push new action to mixpanel.
	 *
	 * @param {string} id Name of the action to track.
	 * @param {*} [action={}] Actions object with custom properties.
	 * @memberof MixpanelService
	 */
	track(id: string, action: any = {}): void {
		mixpanel.track(id, action);
	}

	/**
	 * setup mixpannel
	 *
	 */
	setup() {
		// mixpanel.loggingEnabled = false;
		this.setSuperProperties({ Platform: 'web' });
	}

	/**
	 * setPeople
	 * Store user profiles in Mixpanel's People Analytics product
	 * @param {Object} properties
	 */
	setPeople(properties: any = {}): void {
		mixpanel.people.set(properties);
	}

	/**
	 * setSuperProperties
	 *
	 * @param {object} properties
	 */
	setSuperProperties(properties) {
		mixpanel.register(properties);
	}

	/**
	 * sendEvent
	 *
	 * @param {string} event
	 * @param {object} properties
	 */
	sendEvent(event: string, properties?) {
		if (properties) {
			mixpanel.track(event, properties);
		} else {
			this.trackEvent(event);
		}
	}

	/**
	 * trackEvent
	 * @param {string} event
	 */
	trackEvent(event: string) {
		mixpanel.track(event);
	}

	/**
	 * Reset Mixpanel
	 */
	logout() {
		mixpanel.reset();
	}

	public getClientProperties(client: any) {
		return {
			// "distinct_id":client.user_id,
			"client_business_name":client.business_name,
			"client_vat":client.tax_reg_number,
			"client_first_name":client.first_name,
			"client_last_name":client.last_name,
			"client_country":client.country_name,
			"client_phone":client.phone,
			"client_email":client.email,
			"client_website":client.website,
			"client_address":client.address,
		};

	}
	public getUserProperties(user: any) {
		return {
			// "distinct_id": user.id,
			"name": user.full_name,
			"first_name": user.first_name,
			"last_name": user.last_name,
			// "Email": user.email,
			"phone_number": user.phone,
			"business_name": user.business_name,
			"business_type": user.business_type,
			// "country": user.country,
			"language": user.language,
			"signup_date": user.signup_date,
			"last_login": user.last_login,
			"last_session": user.last_login,
			"subscription_status": user.subscription_status,
			'signup_source': user.signup_source,
			'subscription': user.subscription_name,
			'subscription_renewed_count': user.subscription_renewed_count,
			'sign_up_method': user.sign_up_method,
		};
	}
	public getTrackProperties(user: any) {
		return {
			"email": user.email,
		};
	}

	public getSubscriptionProperties(user: any) {
		return {
			// "distinct_id": user.id,
			"plan": user.subscription.plan,
			"plan_name": user.subscription.plan_name,
			"plan_frequency": user.subscription.plan_frequency,
			"price": user.subscription.price+' SAR',
			"plan_payment_method": user.subscription.plan_payment_method
		};
	}

	public setUserProperties(properties: any) {
		this.identify(this.userInfo?.id);
		mixpanel.people.set(properties);
	}

	unionUserProperties(properties: any) {
		this.identify(this.userInfo?.id);
		for (const [key, value] of Object.entries(properties)) {
		  mixpanel.people.union(key, Array.isArray(value) ? value : [value]);
		}
	}
}
